import React, { useState }from "react"
import { checkInputs } from "../checkInputs"
import "./particulier.css"
import VerificationMail from "./VerificationMail"

const Mail = (): JSX.Element => {
    let [page, setPage] = useState<JSX.Element>(
        <div id="mail" className="inscription">
            <h1>email address</h1>
            
            <p>Your email address will be used as your login ID.</p>
            <input type="text" name="adresse_mail" placeholder="email address" required />

            <button onClick={ () => {
                if (checkInputs())
                    setPage(<VerificationMail />) 
            } }>Validate</button>
        </div>
    )

    return page
}

export default Mail